import React, { useEffect, useRef } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CloseIcon from '@mui/icons-material/Close';

const SystemBanner = ({ children, action, show = true, onDismiss }) => {
  const bannerRef = useRef(null);

  useEffect(() => {
    if (bannerRef.current && show) {
      const height = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty('--banner-height', `${height}px`);
    } else {
      document.documentElement.style.setProperty('--banner-height', '0px');
    }
  }, [show, children]);

  if (!show) return null;

  return (
    <Box
      ref={bannerRef}
      sx={{
        backgroundColor: 'secondary.main',
        color: 'secondary.contrastText',
        padding: { xs: '4px 16px', sm: '6px 24px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        width: '100%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1500,
        flexWrap: 'nowrap'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, flex: 1 }}>
        <NotificationsIcon sx={{ fontSize: 20 }} />
        <Typography
          variant="body2"
          component="span"
          sx={{
            fontWeight: 500,
            display: 'inline',
            lineHeight: 1.4,
            fontSize: { xs: '0.8rem', sm: '0.875rem' },
            textAlign: 'center'
          }}
        >
          {children}
        </Typography>
      </Box>
      {action && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {action}
        </Box>
      )}
      {onDismiss && (
        <IconButton
          onClick={onDismiss}
          size="small"
          sx={{
            color: 'inherit',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.1)'
            }
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default SystemBanner;
